import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, serchSelectManage } from "@/mixins/index";
import { getAll, getGameId, getPlatformId, getChannelPkgId, getGamePlatform, getPlatformChannel, getChannelPkgList, relationSetting } from "@/api/relation";
export default {
  name: "relation",
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      gameList: [],
      channelList: [],
      platformList: [],
      isband: false,
      // 默认显示未绑定 (false)
      allPkgList: [],
      // 保存从 getAll 接口获取的全部包名列表
      boundPkgIds: [],
      pkgList: [],
      channelIds: [],
      platFormIds: [],
      pkgIds: [],
      multipleSelection: [],
      multipleSelection2: [],
      multipleSelection3: [],
      gameData: [],
      gameId: "",
      platId: "",
      channelId: "",
      total: 0,
      page: 1,
      gameshow: true,
      plshow: false,
      // 平台
      canshow: false,
      // 渠道
      pkgshow: false,
      // 包名
      forming: {
        click_game_id: '',
        click_platform_id: '',
        click_channel_id: '',
        select_platform_ids: '',
        select_channel_ids: '',
        select_pkg_ids: ''
      },
      oneRow: {},
      towRow: {},
      therrRow: {}
    };
  },
  created: function created() {},
  activated: function activated() {
    var _this = this;

    // 获取所有平台数据
    getAll().then(function (res) {
      _this.gameList = res.data.game;
      _this.channelList = res.data.channel;
      _this.allPkgList = res.data.pkg; //this.pkgList = res.data.pkg;

      _this.platformList = res.data.platform;

      if (_this.oneRow.game_id) {
        _this.gameClick(_this.oneRow, true);
      }
    });
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      var _this$searchData = _objectSpread({}, this.searchData),
          game = _this$searchData.game,
          platform = _this$searchData.platform,
          channel = _this$searchData.channel,
          pkg = _this$searchData.pkg;

      var params = {
        game: game,
        platform: platform,
        channel: channel,
        pkg: pkg
      };
      getAll(params).then(function (res) {
        console.log("");
        _this2.gameList = res.data.game;
        _this2.channelList = res.data.channel;
        _this2.allPkgList = res.data.pkg; //this.pkgList = res.data.pkg;

        _this2.platformList = res.data.platform;

        if (_this2.oneRow.game_id) {
          _this2.gameClick(_this2.oneRow, true);
        }
      });
    },
    //   点击游戏列表获取平台相关接口
    gameClick: function gameClick(row) {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isHide, game_id, _yield$getGameId, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isHide = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
                _this3.oneRow = row;
                _this3.multipleSelection = [];
                _this3.gameId = row.game_id;
                game_id = {
                  game_id: _this3.gameId
                };
                _this3.forming.click_game_id = row.game_id;
                _context.next = 8;
                return getGameId(game_id);

              case 8:
                _yield$getGameId = _context.sent;
                data = _yield$getGameId.data;

                _this3.platformList.forEach(function (e) {
                  data.platform.forEach(function (v) {
                    if (e.platform_id == v) {
                      _this3.multipleSelection.push(e);
                    }
                  });
                });

                _this3.handleSelectionChange(_this3.multipleSelection);

                _this3.plshow = true;
                _this3.canshow = false;
                _this3.pkgshow = false;

                if (_this3.towRow.platform_id && isHide) {
                  _this3.platformClick(_this3.towRow, isHide);
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    platformClick: function platformClick(row) {
      var _arguments2 = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isHide, platform_id, _yield$getPlatformId, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isHide = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : false;
                _this4.towRow = row;
                _this4.multipleSelection2 = [];
                _this4.platId = row.platform_id;
                platform_id = {
                  platform_id: _this4.platId
                };
                _this4.forming.click_platform_id = row.platform_id;
                _context2.next = 8;
                return getPlatformId(platform_id);

              case 8:
                _yield$getPlatformId = _context2.sent;
                data = _yield$getPlatformId.data;

                _this4.channelList.forEach(function (e) {
                  data.channel.forEach(function (v) {
                    if (e.channel_id == v) {
                      _this4.multipleSelection2.push(e);
                    }
                  });
                });

                _this4.handleSelectionChange2(_this4.multipleSelection2);

                _this4.plshow = true;
                _this4.canshow = true;
                _this4.pkgshow = false;

                if (_this4.therrRow.channel_id && isHide) {
                  _this4.channelClick(_this4.therrRow);
                }

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    channelClick: function channelClick(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var channel_id, _yield$getChannelPkgI, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.therrRow = row;
                _this5.multipleSelection3 = [];
                _this5.channelId = row.channel_id;
                channel_id = {
                  channel_id: _this5.channelId,
                  platform_id: _this5.platId
                };
                _this5.forming.click_channel_id = row.channel_id;
                _context3.next = 7;
                return getChannelPkgId(channel_id);

              case 7:
                _yield$getChannelPkgI = _context3.sent;
                data = _yield$getChannelPkgI.data;
                _this5.boundPkgIds = data.pkg || [];

                _this5.filterPkgList(); // this.pkgList.forEach((e) => {
                //   data.pkg.forEach((v) => {
                //     if (e.pkg_id == v) {
                //       this.multipleSelection3.push(e);
                //     }
                //   });
                // });
                // this.handleSelectionChange3(this.multipleSelection3);


                _this5.plshow = true;
                _this5.canshow = true;
                _this5.pkgshow = true;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    filterPkgList: function filterPkgList() {
      var _this6 = this;

      if (this.isband) {
        // 过滤出已绑定的数据
        this.pkgList = this.allPkgList.filter(function (item) {
          return _this6.boundPkgIds.includes(item.pkg_id);
        });
      } else {
        // 过滤出未绑定的数据
        this.pkgList = this.allPkgList.filter(function (item) {
          return !_this6.boundPkgIds.includes(item.pkg_id);
        });
      } // 切换列表后重新控制表格的勾选状态


      this.$nextTick(function () {
        _this6.multipleSelection3 = [];

        if (_this6.isband) {
          // 在已绑定列表中，默认全部勾选（取消勾选代表解绑）
          _this6.multipleSelection3 = _toConsumableArray(_this6.pkgList);
        } else {
          // 在未绑定列表中，默认不勾选（勾选代表新增绑定）
          _this6.multipleSelection3 = [];
        }

        _this6.handleSelectionChange3(_this6.multipleSelection3);
      });
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      var _this7 = this;

      this.$refs.multipleTable.clearSelection();

      if (rows) {
        rows.forEach(function (item) {
          _this7.$refs.multipleTable.toggleRowSelection(item);
        });
      }
    },
    handleSelectionChange2: function handleSelectionChange2(rows) {
      var _this8 = this;

      this.$refs.multipleTable2.clearSelection();

      if (rows) {
        rows.forEach(function (item) {
          _this8.$refs.multipleTable2.toggleRowSelection(item);
        });
      }
    },
    handleSelectionChange3: function handleSelectionChange3(rows) {
      var _this9 = this;

      this.$refs.multipleTable3.clearSelection();

      if (rows) {
        rows.forEach(function (item) {
          _this9.$refs.multipleTable3.toggleRowSelection(item);
        });
      }
    },
    // 设置平台关联
    selectionChange: function selectionChange(val) {
      var _this10 = this;

      this.platFormIds = [];
      val.forEach(function (item) {
        _this10.platFormIds.push(item.platform_id);
      });
    },
    addplatId: function addplatId() {
      var _this11 = this;

      this.forming.select_platform_ids = this.platFormIds.join(",");
      this.forming.select_channel_ids = this.channelIds.join(","); // this.forming.select_pkg_ids = this.pkgIds.join(","),

      var nextBoundPkgIds = [];

      if (this.isband) {
        // 【当前在已绑定列表】
        // 表格中选中的项代表保留绑定，没选中的项自动解除绑定
        nextBoundPkgIds = _toConsumableArray(this.pkgIds);
      } else {
        // 【当前在未绑定列表】
        // 原有的已绑定数据 + 当前选中的未绑定数据 (合并去重)
        nextBoundPkgIds = Array.from(new Set([].concat(_toConsumableArray(this.boundPkgIds), _toConsumableArray(this.pkgIds))));
      } // 赋值给提交参数


      this.forming.select_pkg_ids = nextBoundPkgIds.join(",");
      relationSetting(this.forming).then(function (res) {
        if (res.status == 200) {
          _this11.$store.dispatch('d2admin/serchSelect/setGame');

          _this11.$message({
            message: res.message,
            type: "success"
          });

          _this11.boundPkgIds = nextBoundPkgIds; // 2. 重新筛选过滤并渲染当前视图
          // 如果原本在“未绑定”选中提交，选中的项会消失并移动到“已绑定”列表
          // 如果原本在“已绑定”取消勾选提交，取消的项会消失并移动到“未绑定”列表

          _this11.filterPkgList();
        } else {
          _this11.$message.error(res.message);
        }
      });
    },
    // 设置渠道关联
    selectionChange1: function selectionChange1(val) {
      var _this12 = this;

      this.channelIds = [];
      val.forEach(function (item) {
        _this12.channelIds.push(item.channel_id);
      });
    },
    addcannel: function addcannel() {
      var _this13 = this;

      var data = {
        platform_id: this.platId,
        channel_ids: this.channelIds.join(",")
      };
      getPlatformChannel(data).then(function (res) {
        if (res.status == 200) {
          _this13.$message({
            message: res.messgae,
            type: "success"
          });
        } else {
          _this13.$message.error(res.message);
        }
      });
    },
    // 设置包名关联
    selectionChange2: function selectionChange2(val) {
      this.pkgIds = val.map(function (item) {
        return item.pkg_id;
      }); // this.pkgIds = [];
      // val.forEach((item) => {
      //   this.pkgIds.push(item.pkg_id);
      // });
    },
    addpkg: function addpkg() {
      var _this14 = this;

      var data = {
        channel_id: this.channelId,
        pkg_ids: this.pkgIds.join(",")
      };
      getChannelPkgList(data).then(function (res) {
        if (res.status == 200) {
          _this14.$message({
            message: res.messgae,
            type: "success"
          });
        } else {
          _this14.$message.error(res.message);
        }
      });
    }
  }
};